import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {BaseModel} from "../../../../../infrastructure/models/base-model";
import {BaseUrlModel} from "../../../../../infrastructure/models/link/base-url-model";

export class FooterModuleLinkModel extends BaseModel {
  itemType: String;
  label: String;
  url: String;
  linkModel: BaseLinkModel;
  isMajor: Boolean;
  position: Number;
  forceFollow: Boolean;

  constructor(itemType: String, label: String, url: String, linkModel: BaseLinkModel, isMajor: Boolean, position: Number, forceFollow: Boolean = false) {
    super();

    this.itemType = itemType;
    this.label = label;
    this.url = url;
    this.linkModel = linkModel;
    this.isMajor = isMajor;
    this.position = position;
    this.forceFollow = forceFollow;

    if (!linkModel && url) {
      this.linkModel = new BaseUrlModel(url, true);
    }
  }
}
